import { render, staticRenderFns } from "./DemoUrl.vue?vue&type=template&id=67591241&scoped=true&"
import script from "./DemoUrl.vue?vue&type=script&lang=ts&"
export * from "./DemoUrl.vue?vue&type=script&lang=ts&"
import style0 from "./DemoUrl.vue?vue&type=style&index=0&id=67591241&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67591241",
  null
  
)

export default component.exports